class InvoiceController extends AbstractController
	@register()
	@inject '$q',
		'$uibModal'
		'translate'
		'InvoiceRepository'
		'OrderRepository'
		'RenderRepository'
		'SEARCH_CONFIGURATION'
		'InvoiceTotalCalculatorService'
		'invoiceStatusEnum': 'BACKEND_INVOICE_STATUS'
		'ToastService'
		'translate'
		'UserInformation'
		'PriceRegionRepository'

	initialize: ->
		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.invoice,
			sortProperty: 'issue_date'
			itemsCount: 0
		})

		@invoiceStatuses = []
		i = 0

		for key, status of @invoiceStatusEnum
			@invoiceStatuses.push({
				id: status,
				index: i++,
				name: @translate('general.invoice.status.' + status)
			})

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.with 'customer',
			'transactions'
			'transactions>order'
			'transactions>order>order_line_items'
			'transactions>order>order_line_items>addon_line_items'
			'transactions>order>order_line_items>bundled_line_items'

		@InvoiceRepository
			.getEntities query
			.then (response) =>
				@invoices = @InvoiceTotalCalculatorService.calculate response

				for invoice in @invoices
					invoice.download_url = @RenderRepository.getRenderUrl('invoices', invoice.id)

				@filterDTO.itemsCount = @invoices.length

				@searching = false

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'status'
			return @$q.when(@invoiceStatuses)

	onBeforeAdvancedSearch: (query, term, filterKey) ->
		if filterKey == 'customer_id'
			query.criteria 'allow_credit', '=', '1'

	openInvoiceFormModal: (invoice = null) ->
		@$uibModal
			.open
				controller: 'InvoiceFormModalController'
				controllerAs: 'invoiceFormModal'
				templateUrl: '@app/report/invoice/modals/invoice.form.modal.view.html'
				resolve:
					invoice: -> invoice
					invoiceStatuses: => @invoiceStatuses
					defaultCurrency: =>
						if invoice?
							return null

						@PriceRegionRepository
							.getEntity(@UserInformation.getMasterUser().price_region_id)
							.then (priceRegion) -> priceRegion?.currency ? null
							.catch -> null
			.result
			.then =>
				@search()

	issueInvoice: ->
		@openInvoiceFormModal()

	showInvoice: (invoice) ->
		@openInvoiceFormModal(invoice)

	sendEmail: (invoiceId) ->
		@InvoiceRepository
			.post "#{invoiceId}/email/send"
			.then =>
				@ToastService.add(
					@translate('bounty.email.sent'),
					@translate('general.invoice'),
					@translate('general.success'),
					'success'
				)
